import React, { useState, useEffect, useRef } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../../config";

function StudentCorrectionIX() {
  const schoolCodeRef = useRef(null);
  const rollNoRef = useRef(null);
  const navigate = useNavigate();

  const reg1Ref = useRef(null);
  const reg2Ref = useRef(null);
  const reg3Ref = useRef(null);

  const token = sessionStorage.getItem("secondaryAdminToken");
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");

  const [loading, setLoading] = useState(false);

  const [candidateId, setCandidateId] = useState("");
  const [schoolCode, setSchoolCode] = useState("");
  const [rollNo, setRollNo] = useState("");
  const [regPart1, setRegPart1] = useState("");
  const [regPart2, setRegPart2] = useState("");
  const [regPart3, setRegPart3] = useState("");

  useEffect(() => {
    if (!permissions[9]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);

  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    }
  }, [token, navigate]);

  // ---------------------------
  // Input Handlers
  // ---------------------------

  const handleCandidateChange = (e) => {
    const value = e.target.value.toUpperCase();
    setCandidateId(value);

    if (value) {
      setSchoolCode("");
      setRollNo("");
      setRegPart1("");
      setRegPart2("");
      setRegPart3("");
    }
  };
  const handleSchoolCodeChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 5);
    setSchoolCode(value);

    if (value) {
      setCandidateId("");
    }

    // move focus to roll no when 5 digits entered
    if (value.length === 5) {
      rollNoRef.current.focus();
    }
    if (value) {
      setCandidateId("");
      setRegPart1("");
      setRegPart2("");
      setRegPart3("");
    }
  };
  const handleRollNoChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
    setRollNo(value);
  };
  const handleRollKeyDown = (e) => {
    if (e.key === "Backspace" && rollNo.length === 0) {
      schoolCodeRef.current.focus();
    }
  };
  const handleSearch = async (e) => {
    e.preventDefault();

    if (
      !candidateId &&
      !schoolCode &&
      !rollNo &&
      !regPart1 &&
      !regPart2 &&
      !regPart3
    ) {
      Swal.fire({
        icon: "warning",
        title:
          "Please Enter Candidate ID OR School Code & Roll No OR Registration No",
      });
      return;
    }

    if (!candidateId && schoolCode && !rollNo) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter Roll No",
      });
      return;
    }

    if (!candidateId && !schoolCode && rollNo) {
      Swal.fire({
        icon: "warning",
        title: "Please Enter School Code",
      });
      return;
    }

    if (schoolCode && schoolCode.length !== 5) {
      Swal.fire({
        icon: "warning",
        title: "School Code must be exactly 5 digits",
      });
      return;
    }

    if (rollNo && rollNo.length !== 4) {
      Swal.fire({
        icon: "warning",
        title: "Roll No must be exactly 4 digits",
      });
      return;
    }

    if (
      (regPart1 || regPart2 || regPart3) &&
      (regPart1.length !== 5 || regPart2.length !== 5 || regPart3.length !== 2)
    ) {
      Swal.fire({
        icon: "warning",
        title: "Registration No must be 5-5-2 digits",
      });
      return;
    }

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Unauthorized",
        text: "Please login again.",
      });
      navigate("/secondary-admin");
      return;
    }

    setLoading(true);

    try {
      const registrationNo =
        regPart1 && regPart2 && regPart3
          ? `${regPart1}-${regPart2}-${regPart3}`
          : "";

      const requestBody = candidateId
        ? {
            candidatE_ID: candidateId,
            schooL_CODE: null,
            rolL_NO: null,
            registratioN_NO: null,
          }
        : registrationNo
          ? {
              candidatE_ID: null,
              schooL_CODE: null,
              rolL_NO: null,
              registratioN_NO: registrationNo,
            }
          : {
              schooL_CODE: schoolCode,
              rolL_NO: rollNo,
              candidatE_ID: null,
              registratioN_NO: null,
            };

      const response = await fetch(
        `${config.API_BASE_URL}/AdminFetchStudentRegistrationCandidateID_CL9`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        },
      );

      const data = await response.json();

      if (response.ok && data?.data?.student_Data) {
        Swal.fire({
          icon: "success",
          title: "Student Found",
          timer: 1200,
          showConfirmButton: false,
        });

        navigate("/secondary-demographic-details-update-page-ix", {
          state: { studentData: data.data.student_Data },
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Not Found",
          text: data.message || "No student found with the given details.",
        });
      }
    } catch (err) {
      console.error("API Error:", err);

      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleswapsubject = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/PreGenSubjectSwap`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Subject swap successfully completed.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data?.message || "Something went wrong.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "API call failed.",
      });
    } finally {
      setLoading(false);
    }
  };
  const handleRegPart1Change = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 5);
    setRegPart1(value);

    if (value) {
      setCandidateId("");
      setSchoolCode("");
      setRollNo("");
      setRegPart2("");
      setRegPart3("");
    }

    // After 5 digits move to 2nd box
    if (value.length === 5) {
      reg2Ref.current?.focus();
    }
  };

  const handleRegPart2Change = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 5);
    setRegPart2(value);

    // After 5 digits move to 3rd box
    if (value.length === 5) {
      reg3Ref.current?.focus();
    }
  };

  const handleRegPart3Change = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 2);
    setRegPart3(value);
  };

  const handleReg2KeyDown = (e) => {
    if (e.key === "Backspace" && regPart2.length === 0) {
      reg1Ref.current?.focus();
    }
  };

  const handleReg3KeyDown = (e) => {
    if (e.key === "Backspace" && regPart3.length === 0) {
      reg2Ref.current?.focus();
    }
  };
  return (
    <>
      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}

        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />

          <div className="main-panel">
            <div className="content-wrapper">
              {/* Header */}
              <div className="row">
                <div className="col-md-12 mb-1">
                  <section className="content-header">
                    <h1>
                      <i className="fa fa-university" /> Student Demographic
                      Details Correction for Class IX
                    </h1>

                    <ol className="breadcrumb">
                      <li>
                        <a
                          onClick={() => navigate("/secondary-admin-dashboard")}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className="fa fa-tachometer"
                            style={{ marginRight: 5 }}
                          ></i>
                          Home
                        </a>
                      </li>
                      <li className="active">
                        Student Correction for Class IX
                      </li>
                    </ol>
                  </section>
                </div>
              </div>

              {/* SEARCH SECTION */}
              <div className="row">
                <div className="card">
                  <div className="card-body">
                    <div className="row align-items-end">
                      {/* Candidate ID */}
                      <div className="col-md-2">
                        <label className="mb-2">Candidate ID</label>
                        <input
                          type="text"
                          className="form-control form-control-xs"
                          value={candidateId}
                          onChange={handleCandidateChange}
                          disabled={
                            schoolCode !== "" ||
                            rollNo !== "" ||
                            regPart1 !== "" ||
                            regPart2 !== "" ||
                            regPart3 !== ""
                          }
                          maxLength={20}
                        />
                      </div>
                      <div className="col-md-1 text-center">
                        <label className="mb-2">Or</label>
                      </div>
                      {/* School Code */}
                      <div className="col-md-2">
                        <label className="mb-2">
                          School Code{" "}
                          <span className="text-danger">(5 Digits)</span>
                        </label>
                        <input
                          ref={schoolCodeRef}
                          type="text"
                          className="form-control form-control-xs"
                          value={schoolCode}
                          onChange={handleSchoolCodeChange}
                          disabled={
                            candidateId !== "" ||
                            regPart1 !== "" ||
                            regPart2 !== "" ||
                            regPart3 !== ""
                          }
                          maxLength={5}
                        />
                      </div>
                      {/* Roll No */}
                      <div className="col-md-2">
                        <label className="mb-2">
                          Roll No{" "}
                          <span className="text-danger">(4 Digits)</span>
                        </label>
                        <input
                          ref={rollNoRef}
                          type="text"
                          className="form-control form-control-xs"
                          value={rollNo}
                          onChange={handleRollNoChange}
                          onKeyDown={handleRollKeyDown}
                          disabled={
                            !schoolCode ||
                            candidateId !== "" ||
                            regPart1 !== "" ||
                            regPart2 !== "" ||
                            regPart3 !== ""
                          }
                          maxLength={4}
                        />
                      </div>
                      <div className="col-md-1 text-center">
                        <label className="mb-2">Or</label>
                      </div>
                      <div className="col-md-4">
                        <label className="mb-2">
                          Registration No&nbsp;
                          <span className="text-danger">
                            (5 digit - 5 digit - 2 digit)
                          </span>
                        </label>
                        <div className="row">
                          <div className="col-md-4">
                            <input
                              ref={reg1Ref}
                              className="form-control form-control-xs"
                              value={regPart1}
                              onChange={handleRegPart1Change}
                              disabled={candidateId || schoolCode || rollNo}
                              maxLength={5}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              ref={reg2Ref}
                              className="form-control form-control-xs"
                              value={regPart2}
                              onChange={handleRegPart2Change}
                              onKeyDown={handleReg2KeyDown}
                              disabled={
                                !regPart1 || candidateId || schoolCode || rollNo
                              }
                              maxLength={5}
                            />
                          </div>

                          <div className="col-md-4">
                            <input
                              ref={reg3Ref}
                              className="form-control form-control-xs"
                              value={regPart3}
                              onChange={handleRegPart3Change}
                              onKeyDown={handleReg3KeyDown}
                              disabled={
                                !regPart2 || candidateId || schoolCode || rollNo
                              }
                              maxLength={2}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Search Button */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                      }}
                      className="mt-2"
                    >
                      <button
                        className="btn btn-primary"
                        style={{ marginTop: "10px" }}
                        onClick={handleSearch}
                      >
                        <i className="fa fa-search"></i> Search
                      </button>
                      &nbsp;
                      <button
                        className="btn btn-success"
                        style={{ marginTop: "10px" }}
                        onClick={handleswapsubject}
                      >
                        <i className="fa fa-retweet"></i> Swap Subject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentCorrectionIX;
